"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFallback = exports.initialize = void 0;
var gatewayCaller_1 = __importDefault(require("@atg/icf-platform/lib/client/gatewayCaller"));
var LoggerService_1 = require("icf-search-client-shared/lib/services/LoggerService");
var StatsDClient_1 = require("icf-search-client-shared/lib/services/StatsDClient");
var promisedState = null;
var gatewayCaller = (0, gatewayCaller_1.default)("da48cfde-b78e-4dca-bd12-d6660fcccf2d");
var domain = null;
var lastSuccessTime;
var lastAttemptTime;
var cacheStatusType = new Set(["HIT", "MISS", "STALE"]);
var initialize = function (args) {
    if (domain) {
        return;
    }
    console.log("Initializing performer fallback module");
    domain = args.domain;
    lastAttemptTime = Date.now();
    StatsDClient_1.statsd.count("recommenders.fallback-init.attempt");
    promisedState = gatewayCaller
        .get({ url: "/v4/performers/fallback", params: { domain: domain }, timeout: 1000 })
        .catch(function (err) {
        LoggerService_1.logger.error("Failed to initialize fallback performers.", err);
        return gatewayCaller.get({ url: "/v4/performers/fallback", params: { domain: domain }, timeout: 1000 }).catch(function (err) {
            LoggerService_1.logger.error("Failed to initialize fallback performers 2 times.", err);
            return gatewayCaller.get({ url: "/v4/performers/fallback", params: { domain: domain }, timeout: 1000 }).catch(function (err) {
                LoggerService_1.logger.error("Failed to initialize fallback performers 3 times.", err);
            });
        });
    })
        .then(function (result) {
        var _a;
        if (result && (result === null || result === void 0 ? void 0 : result.status) === 200) {
            lastSuccessTime = Date.now();
            StatsDClient_1.statsd.count("recommenders.fallback-init.success");
            var rawStatus = (_a = result === null || result === void 0 ? void 0 : result.headers) === null || _a === void 0 ? void 0 : _a["x-cache-status"];
            var cacheStatus = cacheStatusType.has(rawStatus) ? rawStatus : "UNKNOWN";
            StatsDClient_1.statsd.count("recommenders.fallback-cache.".concat(cacheStatus));
        }
        else {
            StatsDClient_1.statsd.count("recommenders.fallback-init.error");
        }
        return { result: result, lastSuccessTime: lastSuccessTime };
    });
};
exports.initialize = initialize;
var getFallback = function () {
    // this function will gets called every time we get the performers list
    // nginx cache is set to 9-11 minutes max age
    // every 8 minutes this function will make a request
    // otherwise will do nothing
    if (Date.now() >= 8 * 60 * 1000 + lastSuccessTime && Date.now() >= 10 * 1000 + lastAttemptTime) {
        lastAttemptTime = Date.now();
        StatsDClient_1.statsd.count("recommenders.fallback-background.attempt");
        gatewayCaller
            .get({ url: "/v4/performers/fallback", params: { domain: domain }, timeout: 1000 })
            .then(function (result) {
            var _a;
            lastSuccessTime = Date.now();
            promisedState = new Promise(function (r) { return r({ result: result, lastSuccessTime: lastSuccessTime }); });
            StatsDClient_1.statsd.count("recommenders.fallback-background.success");
            var rawStatus = (_a = result === null || result === void 0 ? void 0 : result.headers) === null || _a === void 0 ? void 0 : _a["x-cache-status"];
            var cacheStatus = cacheStatusType.has(rawStatus) ? rawStatus : "UNKNOWN";
            StatsDClient_1.statsd.count("recommenders.fallback-cache.".concat(cacheStatus));
        })
            .catch(function (err) {
            LoggerService_1.logger.error("Failed to refresh fallback.", err);
            StatsDClient_1.statsd.count("recommenders.fallback-background.error");
        });
    }
    return promisedState;
};
exports.getFallback = getFallback;
//# sourceMappingURL=PerformerFallback.js.map